import { useEffect, useState } from "react";
import api from "../api/client";
import { useAuth } from "../context/AuthContext";
import { Input, Alert } from "../components/Ui";
import "./User.css";

const QUICK = [100, 500, 1000, 2000];

export default function Wallet() {
  const { user, refreshUser } = useAuth();
  const [history, setHistory] = useState([]);
  const [amount, setAmount] = useState("");
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/wallet/history").then((r) => setHistory(r.data.history)).catch(() => {});
    refreshUser();
  }, [refreshUser]);

  async function topUp(e) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      // The server validates and persists the amount BEFORE returning a redirect,
      // and only ever credits from the signed webhook. We never build a payment
      // request client-side.
      const { data } = await api.post("/wallet/topup", { amount: Number(amount) });
      if (data.data && data.data.result && data.data.result.payment_url) {
        window.location.href = data.data.result.payment_url;
      } else {
        setError("Gateway did not return a payment link.");
        setBusy(false);
      }
    } catch (err) {
      setError(err.message);
      setBusy(false);
    }
  }

  return (
    <div className="container" style={{ maxWidth: 680, padding: "32px 16px" }}>
      <div className="card" style={{ padding: 24, marginBottom: 32 }}>
        <div className="muted small">Wallet balance</div>
        <div className="tabular" style={{ fontSize: 36, fontWeight: 800, marginTop: 4 }}>
          ₹{Number(user?.balance || 0).toFixed(2)}
        </div>
      </div>

      <form onSubmit={topUp} style={{ marginBottom: 40 }}>
        <h2 className="pi-label">Add money</h2>
        <div className="quick">
          {QUICK.map((v) => (
            <button key={v} type="button" onClick={() => setAmount(String(v))}
              className={`quick-btn${amount === String(v) ? " on" : ""}`}>
              ₹{v}
            </button>
          ))}
        </div>
        <div style={{ margin: "16px 0" }}>
          <Input label="Or enter an amount" inputMode="numeric" value={amount}
            onChange={(e) => setAmount(e.target.value.replace(/\D/g, ""))} />
        </div>
        <Alert>{error}</Alert>
        <button className="btn primary big" disabled={busy || !(Number(amount) >= 10)}>
          {busy ? "Redirecting…" : `Pay ₹${amount || 0} via UPI`}
        </button>
      </form>

      <h2 className="pi-label">History</h2>
      <div className="list">
        {history.length === 0 && <p className="center muted" style={{ padding: 40 }}>No transactions yet.</p>}
        {history.map((h) => (
          <div key={h._id} className="row">
            <div className="grow">
              <div style={{ fontWeight: 700, fontSize: 14 }}>{h.orderInfo}</div>
              <div className="muted small">{new Date(h.createdAt).toLocaleString()}</div>
            </div>
            <div className="tabular" style={{ fontWeight: 800, color: h.type === "order" ? "var(--bad)" : "var(--ok)" }}>
              {h.type === "order" ? "−" : "+"}₹{h.amount}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
